const locale = {
	TAB_EVALUATIONS: 'Evaluations',
	TAB_COURSES: 'Courses',

	// #region Users Skills
	TAB_SKILLS_USERS: 'Skills matrix',

	SKILLS_USERS_DIALOG_DETAILS_TITLE: '{user} - {skill}',
	SKILLS_USERS_DIALOG_DETAILS_ACTION_ADD: 'Add evaluation',
	// #endregion

	// #region Skills fields
	DETAILS_SKILLS_FIELD_TITLE: 'Title',
	DETAILS_SKILLS_FIELD_WARNING: 'Warning',
	DETAILS_SKILLS_FIELD_BLOCKED: 'Blocked',
	DETAILS_SKILLS_FIELD_TYPE: 'Skill Type',
	DETAILS_SKILLS_FIELD_ASSIGNED_USER: 'Reference',
	DETAILS_SKILLS_FIELD_TAGS: 'Tags',
	// #endregion

	// #region Skills fields
	DETAILS_SKILLS_EVALUATIONS_FIELD_SKILL: 'Skill',
	DETAILS_SKILLS_EVALUATIONS_FIELD_USER_ASSIGNED: 'User',
	DETAILS_SKILLS_EVALUATIONS_FIELD_LEVEL: 'Level',
	DETAILS_SKILLS_EVALUATIONS_FIELD_DATE_FROM: 'Evaluation date',
	DETAILS_SKILLS_EVALUATIONS_FIELD_DATE_TO: 'Expire date',

	DIALOG_SKILLS_EVALUATIONS_ADD_TITLE: 'Add evaluation',
	DIALOG_SKILLS_EVALUATIONS_EDIT_TITLE: 'Edit evaluation'
	// #endregion
};

export default locale;
